import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdatePropertyDetails } from '@acp/shared';
import { editPropertyDetails } from '../../service';

type UseEditPropertyDetailsOpts = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

function useUpdatePropertyDetailsMutation(
    propertyId: number,
    opts: UseEditPropertyDetailsOpts = {}
) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: (data: UpdatePropertyDetails) => editPropertyDetails(propertyId, data),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['property', propertyId],
            });

            void queryClient.removeQueries({
                queryKey: ['property', propertyId],
            });

            void queryClient.invalidateQueries({
                queryKey: ['update-properties'],
            });

            if (opts.onSuccess !== undefined) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts.onError !== undefined) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useUpdatePropertyDetailsMutation };
